import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: 5em;
`;
export const SubContainer = styled.div`
  width: 100%;
  padding: 0 10%;
  display: flex;
  margin-bottom: 5em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
    padding: 0 5%;
  }
`;
export const Left = styled.div`
  width: 35%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Right = styled.div`
  width: 65%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Content = styled.div`
  width: 32.3125rem;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const SubHeading = styled.div`
  display: flex;
  justify-content: space-between;
  color: #d9d9d9;
  width: 100%;
  margin-bottom: 0.81em;

  h1 {
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor: pointer;
  }
  p {
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 1.75em;
    width: 100%;
    h1 {
      /* width: 100%; */
    }
  }
`;
export const MyBusiness = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5em;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const BusinessList = styled.div`
  width: 100%;
  height: 2.5625rem;
  /* width: 25.5625rem; */
  display: flex;
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(190, 190, 190, 0.18);
  padding: 0 1em;
  align-items: center;

  .link {
    /* all: inherit; */
    width: 100%;
    display: flex;
    height: 100%;
    align-items: center;
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.96em;
    border-radius: 50%;
  }
  div {
    display: flex;
    justify-content: space-between;
    color: #777;
    text-align: center;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 80%;
  }
`;
export const Remove = styled.div`
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(190, 190, 190, 0.18);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 6.1875em;
  height: 2.5625rem;
  flex-shrink: 0;
  padding: 0 0.56em;
  cursor: pointer;
  p {
    color: #777;
    text-align: center;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 0%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    /* width: 20%; */
  }
`;
export const HeaderContainer = styled.div`
  width: 100%;
  color: #000000;
  font-weight: 700;
  display: flex;
  padding: 3.2em 9%;
  align-items: center;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2.25em 5%;
    justify-content: center;
  }
`;
export const Suggestion = styled.div`
  padding: 0 5%;
  width: 50%;
  display: none;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    display: block;
  }
`;
export const SuggestionHeading = styled.div`
  color: #c9c9c9;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0.37em;
`;
export const BusinessSuggestionList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  .link {
    all: inherit;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const List = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  height: 2.5625rem;
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(190, 190, 190, 0.18);
  padding: 0em 1em;
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.96em;
    border-radius: 50%;
  }
  > p {
    /* width: 40%; */
    color: #777;
    text-align: right;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 0%;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    height: 2.5625rem;
    padding: 0 1em;
  }
`;
export const Text = styled.div`
  display: flex;
  /* width: 100%; */
  flex: 1;
  color: #777;
  text-align: left;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const Add = styled.div`
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(190, 190, 190, 0.18);
  display: flex;
  justify-content: center;
  gap: 0.56em;
  align-items: center;
  width: 6.1875rem;
  height: 2.5625rem;
  flex-shrink: 0;
  padding: 0 0.56em;
  cursor: pointer;
  p {
    color: #777;
    text-align: center;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 0%;
  }
`;
export const Empty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4em;
  width: 100%;
  p {
    margin-left: 20%;
    margin-top: 3.1em;
    color: #c9c9c9;
    text-align: center;
    font-family: Poppins;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    p {
      margin-left: 0%;
      width: 11.75rem;
    }
  }
`;
